var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFuncaoSubtracao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-subtracao",
    transform: "translate(-409 -912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2194",
    "data-name": "Grupo 2194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2193",
    "data-name": "Grupo 2193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2192",
    "data-name": "Grupo 2192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subtration",
    transform: "translate(415.152 906.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1259",
    "data-name": "Grupo 1259",
    transform: "translate(-1.151 27.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1258",
    "data-name": "Grupo 1258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    "data-name": "Caminho 745",
    d: "M36.743,233.569H.954a2.105,2.105,0,1,0,0,4.211H36.743a2.105,2.105,0,1,0,0-4.211Z",
    transform: "translate(1.151 -233.569)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_443",
    "data-name": "Ret\\xE2ngulo 443",
    width: 50,
    height: 50,
    transform: "translate(409 912)",
    fill: "none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoSubtracao);
export default __webpack_public_path__ + "static/media/ico-funcao-subtracao.06f3358f.svg";
export { ForwardRef as ReactComponent };